import { render, staticRenderFns } from "./IcDeclaration.vue?vue&type=template&id=4031e131"
import script from "./IcDeclaration.vue?vue&type=script&lang=js"
export * from "./IcDeclaration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports